import { render, staticRenderFns } from "./pop.vue?vue&type=template&id=1c6dbe0f&"
import script from "./pop.vue?vue&type=script&lang=js&"
export * from "./pop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports